import { render } from "./RoomStatus.vue?vue&type=template&id=4cbbe744&scoped=true"
import script from "@/assets/js/RoomStatus.js?vue&type=script&lang=js"
export * from "@/assets/js/RoomStatus.js?vue&type=script&lang=js"

import "./RoomStatus.vue?vue&type=style&index=0&id=4cbbe744&scoped=true&lang=css"

import exportComponent from "/tmp/workdir/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbbe744"]])

export default __exports__